import { useContext, useState, useEffect } from "react";
import "./navbar.scss";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import BusinessIcon from "@mui/icons-material/Business";
import MenuIcon from "@mui/icons-material/Menu";
import { DarkModeContext } from "../../context/darkModeContext";
import { useUserProfile } from "../../context/UserProfileContext";
import NotificationBell from "./NotificationBell";
import { format } from "date-fns";
import { es } from "date-fns/locale";

interface NavbarProps {
  onMenuToggle?: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ onMenuToggle }) => {
  const { dispatch, darkMode } = useContext(DarkModeContext);
  const { userProfile } = useUserProfile();
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const getInitials = (name: string): string =>
    name.split(" ").map((w) => w[0]).join("").toUpperCase().substring(0, 2);

  const formatDate = (date: Date) =>
    format(date, "EEEE, d 'de' MMMM", { locale: es });

  const formatTime = (date: Date) => format(date, "HH:mm:ss");

  const getSucursalName = () => {
    if (!userProfile.sucursal) return "Sistema POS";
    // @ts-ignore
    return userProfile.sucursal?.Nombre || userProfile.nombreSucursal || "Sistema POS";
  };

  const getRolName = () => {
    if (!userProfile.rol) return "Sin Rol";
    // @ts-ignore
    return userProfile.rol?.Nombre || userProfile.nombreRol || "Sin Rol";
  };

  return (
    <div className={`navbar ${darkMode ? "dark" : ""}`}>
      <div className="wrapper">
        {/* Hamburger (only visible on mobile via CSS) */}
        <button className="hamburger-btn" onClick={onMenuToggle} aria-label="Abrir menú">
          <MenuIcon />
        </button>

        {/* Left */}
        <div className="navbar-left">
          <div className="sucursal-info">
            <BusinessIcon className="icon-small" />
            <span className="sucursal-name">{getSucursalName()}</span>
          </div>
          <div className="divider-vertical" />
          <div className="datetime-info">
            <AccessTimeIcon className="icon-small" />
            <div className="datetime-content">
              <span className="date">{formatDate(currentTime)}</span>
              <span className="time">{formatTime(currentTime)}</span>
            </div>
          </div>
        </div>

        {/* Right */}
        <div className="navbar-right">
          <div className="item tooltip-container">
            {darkMode ? (
              <LightModeOutlinedIcon
                className="icon"
                onClick={() => dispatch({ type: "TOGGLE" })}
              />
            ) : (
              <DarkModeOutlinedIcon
                className="icon"
                onClick={() => dispatch({ type: "TOGGLE" })}
              />
            )}
            <span className="tooltip">{darkMode ? "Modo Claro" : "Modo Oscuro"}</span>
          </div>

          <NotificationBell />

          <div className="item user-section">
            <div className="user-info">
              <span className="user-name">{userProfile?.nombreCompleto || "Usuario"}</span>
              <span className="user-role">{getRolName()}</span>
            </div>
            <div className="avatar">
              {userProfile?.imagen ? (
                <img
                  src={`${process.env.REACT_APP_API_URL}${userProfile.imagen}`}
                  alt={userProfile.nombreCompleto || ""}
                />
              ) : userProfile?.nombreCompleto ? (
                getInitials(userProfile.nombreCompleto)
              ) : (
                "UE"
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
